/**
 * mwApp.liveEvents module <br>
 * Work with LiveEvents: show/add/edit/remove
 *
 * @namespace mwApp/liveEvents
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/liveEvents
 * @see mwApp/liveEvents
 *
 * @ngdoc config
 * @name mwApp/liveEvents.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /live-events
     */
    .state('app.liveEvents', {
      abstract: true,
      url: '/live-events',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/liveEvents.controller:PpvListCtrl}
     * @name /live-events
     * @memberof mwApp/liveEvents.config:ConfigRoutes
     */
    .state('app.liveEvents.list', {
      url: '',
      templateUrl: 'components/liveEvents/views/liveEvents.html',
      controller: 'LiveEventsCtrl as vm',
      label: 'Live Events',
      access: ''
    })

    /**
     * abstract state for /:leId
     */
    .state('app.liveEvents.liveEvent', {
      abstract: true,
      url: '/:leId',
      template: '<ui-view/>',
      resolve: {
        extra: /* @ngInject */ function (LiveEvent) {
          return LiveEvent.loadExtra()
        },
        le: /* @ngInject */ function ($transition$, LiveEvent) {
          const { leId: id } = $transition$.params()
          return (+id) ? LiveEvent.load({ id }) : new LiveEvent()
        },
        allNetworksById: /* @ngInject */function (extra, le) {
          const networks = [...extra.networks, ...le.networks]
          return networks.reduce((acc, item) => Object.assign(acc, { [item.id]: item }), {})
        }
      }
    })

    /**
     * controller {@link mwApp/liveEvents.controller:AddLiveEventCtrl}
     * @name /live-events/:leId
     * @memberof mwApp/liveEvents.config:ConfigRoutes
     */
    .state('app.liveEvents.liveEvent.edit', {
      url: '',
      templateUrl: 'components/liveEvents/views/addLiveEvent.html',
      controller: 'AddLiveEventCtrl as vm',
      label: '{{::leId | addOrEdit}} Live Event',
      access: ':leId (+) ! IF createLiveEvent ELSE editLiveEvent'
    })

    /**
     */
    .state('app.liveEvents.liveEvent.contentSets', {
      url: '/contentSets',
      templateUrl: 'components/common/components/assignContentSets/assignContentSets.html',
      controller: 'AssignContentSetsCtrl as vm',
      label: 'Edit Content Sets',
      resolve: {
        contentItem: /* @ngInject */ function ($transition$, LiveEvent) {
          const { leId: id } = $transition$.params()
          return (+id) ? LiveEvent.load({ id }) : new LiveEvent()
        },

        allContentSets: /* @ngInject */ function (LiveEvent, le) {
          return LiveEvent.loadAvailableContentSets(le)
        }
      }
    })
}
